import React, { useEffect } from 'react'
import { useQuery } from 'urql'
import { MeQuery } from '../modules/authentication/queries'
import { BrowserRouter } from 'react-router-dom'
import { NoAuthRoutes } from './NoAuthRoutes'
import { AuthRoutes } from './AuthRoutes'
import { UserContext } from '../context/UserContext'
import { useBusinessLocation } from '../context/BusinessLocationContext'

export const Bootstrap: React.FC = () => {
  const [{ data, fetching }] = useQuery({
    query: MeQuery,
  })

  const me = data?.me

  const { selectedLocation, setLocation, setAvailableLocations } =
    useBusinessLocation()

  useEffect(() => {
    const newAvailableLocations = me?.business?.scanLocations ?? []

    setAvailableLocations(newAvailableLocations)

    if (selectedLocation) {
      return
    }

    if (me?.business?.scanLocations?.length === 1) {
      setLocation(me?.business?.scanLocations[0])
    }
  }, [me, selectedLocation, setAvailableLocations, setLocation])

  if (fetching) {
    return null
  }

  // Users without a business will be shown an error screen
  if (me && !me?.business) {
    return (
      <div className={'flex h-screen'}>
        <div className={'m-auto'}>
          <h1 className={'text-3xl font-bold mb-4'}>No business</h1>
          <p>
            You are logged in as a user without a business. Please contact your
            administrator to be added to a business.
          </p>
        </div>
      </div>
    )
  }

  return (
    <BrowserRouter>
      <UserContext.Provider value={data?.me ?? null}>
        {data?.me ? <AuthRoutes /> : <NoAuthRoutes />}
      </UserContext.Provider>
    </BrowserRouter>
  )
}
